import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { googleSession } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    // clean the fragment from the URL
    window.history.replaceState(null, "", window.location.pathname);
    (async () => {
      if (!sessionId) { navigate("/login", { replace: true }); return; }
      try {
        const u = await googleSession(sessionId);
        setUser(u);
        navigate("/studio", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center gap-3" data-testid="auth-callback">
      <Loader2 className="h-7 w-7 animate-spin text-[#FF6A5E]" />
      <p className="text-sm text-slate-400">Signing you in…</p>
    </div>
  );
}
